import { Box } from '@mui/material';
import { Ref } from 'react';
import { MessageReactions, MessageReactionsProps } from './message-reactions';
import { ReactionPicker } from './reaction-picker';
import { ReactionPickerState } from './use-reaction-picker';

export interface ReactionsFooterProps extends Omit<MessageReactionsProps, 'onAddClick'> {
  reactionsRef: Ref<HTMLDivElement>;
  picker: Pick<ReactionPickerState, 'anchorEl' | 'isOpen' | 'openAt' | 'close'>;
  onSelect: (emoji: string) => void;
}

/** A message's reaction chips with the picker they and the message open. */
export const ReactionsFooter = ({
  reactionsRef,
  picker,
  onSelect,
  reactions,
  canReact,
  onToggle,
  notice,
}: ReactionsFooterProps) => (
  <>
    <Box ref={reactionsRef} sx={{ marginTop: reactions.length ? 0.75 : 0 }}>
      <MessageReactions
        reactions={reactions}
        canReact={canReact}
        onToggle={onToggle}
        onAddClick={picker.openAt}
        notice={notice}
      />
    </Box>
    <ReactionPicker
      anchorEl={picker.anchorEl}
      open={picker.isOpen}
      onClose={picker.close}
      onSelect={onSelect}
      notice={notice}
    />
  </>
);
